// src/api/index.js
import axios from "axios";

const api = axios.create({
  baseURL: "https://dgps.co.in/api",
  // baseURL: process.env.REACT_APP_API_URL || "https://school.righten.in/api",
  // timeout: 15000,
});

// Helper: detect school identifier dynamically
// 🔹 Detect school dynamically
const getSchoolIdentifier = () => {
  try {
    // 1️⃣ Query param (example: ?domain=dgps.co.in)
    const params = new URLSearchParams(window.location.search);
    const domain =
      params.get("domain") ||
      params.get("school") ||
      params.get("code");

    if (domain) {
      localStorage.setItem("school_domain", domain);
      return domain;
    }

    // 2️⃣ From localStorage
    const saved = localStorage.getItem("school_domain") || localStorage.getItem("school_code");
    if (saved) return saved;

    // 3️⃣ Fallback — current hostname
    return window.location.hostname;
  } catch (e) {
    console.warn("[SchoolIdentifier] Error:", e);
    return window.location.hostname;
  }
};

// Request interceptor: token + school identifier set করবে
api.interceptors.request.use(
  (config) => {
    try {
      const token = localStorage.getItem("token");
      const sid = localStorage.getItem("school_id");
      const userType = localStorage.getItem("userType");

      const schoolIdentifier = getSchoolIdentifier();

      // console.log(
      //   "[API Interceptor]",
      //   "\n→ URL:", config.url,
      //   "\n→ Method:", config.method,
      //   "\n→ Token:", Boolean(token),
      //   "\n→ school_id:", sid,
      //   "\n→ userType:", userType,
      //   "\n→ X-School-Identifier:", schoolIdentifier
      // );

      config.headers = config.headers || {};

      // ✅ 1️⃣ Bearer token (for logged-in users)
      if (token && token !== "null" && token !== "undefined") {
        config.headers.Authorization = `Bearer ${token}`;
      }

      // ✅ 2️⃣ School-based headers
      if (userType === "school" && sid) {
        config.headers["X-School-Id"] = sid;
      } else {
        // Public / Admission page users
        config.headers["X-School-Identifier"] = schoolIdentifier;
      }

    } catch (e) {
      //console.warn("[API Interceptor] error reading localStorage", e);
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default api;
